import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7068ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-item" }
const _hoisted_2 = { class: "group-item-text" }
const _hoisted_3 = { class: "main bold" }
const _hoisted_4 = { class: "sub" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_7 = { class: "circle-icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_11 = { class: "title bold" }
const _hoisted_12 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_14 = { class: "menu-item" }
const _hoisted_15 = { class: "title bold" }
const _hoisted_16 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_18 = { class: "title bold" }
const _hoisted_19 = { class: "group-item" }
const _hoisted_20 = { class: "group-item-text" }
const _hoisted_21 = { class: "main bold" }
const _hoisted_22 = { class: "sub" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_25 = { class: "circle-icon" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_bottom_pop_up_item_wrapper = _resolveComponent("bottom-pop-up-item-wrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.groupList.length)
      ? (_openBlock(), _createBlock(_component_bottom_pop_up_item_wrapper, {
          key: 0,
          title: _ctx.$localize('share.by.network.popup.title'),
          onViewAll: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openGroups'))),
          noHideAll: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (group) => {
              return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                class: "group-item",
                key: group.id
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.resolveGroupPhotoUrl(group),
                      alt: "group photo"
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("p", _hoisted_3, _toDisplayString(group.name), 1),
                      _createElementVNode("p", _hoisted_4, _toDisplayString(group.groupInfo), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "group-item-checkbox",
                      onClick: ($event: any) => (_ctx.$emit('onSelectGroup', group))
                    }, [
                      (group.selected)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_5)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _hoisted_9,
    _createElementVNode("div", null, [
      (_ctx.contactList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$localize('share.by.network.popup.everybody')), 1),
            _createElementVNode("div", {
              class: "group-item-checkbox",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSelectAll')))
            }, [
              (_ctx.selectedAll)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_13
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$localize('share.by.network.popup.me')), 1),
        _createElementVNode("div", {
          class: "group-item-checkbox",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onDeselectAll')))
        }, [
          (_ctx.deselectedAll)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_17
    ]),
    _createElementVNode("div", null, [
      (_ctx.contactList.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "menu-item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowContacts = !_ctx.isShowContacts))
          }, [
            _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.$localize('share.by.network.popup.specific')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["icon-rotate icon-back", { 'icon-half-rotate': _ctx.isShowContacts }])
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowContacts)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item_wrapper, {
            key: 1,
            onViewAll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('openSpecificPeople'))),
            noHideAll: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactList, (my) => {
                return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  class: "group-item",
                  key: my.user.accountId
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        src: _ctx.resolveContactPhotoUrl(my),
                        alt: "contact photo"
                      }, null, 8, _hoisted_26)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.resolveFullName(my)), 1),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(my.user.speciality), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "group-item-checkbox",
                        onClick: ($event: any) => (_ctx.$emit('onSelectContact', my))
                      }, [
                        (my.selected)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_23)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_27
    ])
  ]))
}